const createBluetoothErrorResult = () => {
  return {
    ok: false,
    action: 'BLUETOOTH_ERROR',
    payload: { reason: 'UNHANDLED_ERROR' },
  }
}

const createGeolocationErrorResult = () => {
  return {
    ok: false,
    reason: 'UNKNOWN',
    distance: null,
    lat: null,
    lon: null,
    accuracyM: null,
  }
}

const settleBluetoothVerification = async (bluetoothPromise) => {
  try {
    return await bluetoothPromise
  } catch (error) {
    return createBluetoothErrorResult()
  }
}

const settleGeolocationVerification = async (geolocationPromise) => {
  try {
    return await geolocationPromise
  } catch (error) {
    return createGeolocationErrorResult()
  }
}

const runParallelVerification = async (bluetoothPromise, geolocationPromise) => {
  const [bluetoothResult, geolocationResult] = await Promise.all([
    settleBluetoothVerification(bluetoothPromise),
    settleGeolocationVerification(geolocationPromise),
  ])

  return { bluetoothResult, geolocationResult }
}

export { runParallelVerification }
